import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../fonts/breuer-headline.css";
import "./stage1_intro.css";
import { setBackButtonUrl } from "../uiSlice";
import { getHouseById } from "../house/housesConfig";
import { getCharacterByIds } from "../character/charactersConfig";
import startBtnImg from "../images/start.png";

function Stage1Intro() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { status, user } = useSelector((state) => state.auth);
  const { houseId, characterId, characterName, wandId, wandName } =
    location.state ?? {};
  const house = houseId ? getHouseById(houseId) : null;
  const character = getCharacterByIds(houseId, characterId);

  useEffect(() => {
    document.documentElement.classList.add("stage1-intro-static-bg");
    document.body.classList.add("stage1-intro-static-bg");
    return () => {
      document.documentElement.classList.remove("stage1-intro-static-bg");
      document.body.classList.remove("stage1-intro-static-bg");
    };
  }, []);

  useEffect(() => {
    dispatch(setBackButtonUrl("/wand"));
  }, [dispatch, status, user]);

  if (!house || !characterId || !character || !wandId) {
    return <Navigate to="/wand" replace />;
  }

  const dialogue =
    character.stage1IntroLine ??
    "Focus your magic... even first-years can shine!";

  const handleStart = () => {
    navigate("/welcome", {
      state: {
        houseId: house.id,
        characterId,
        characterName,
        wandId,
        wandName,
      },
    });
  };

  return (
    <div className="stage1-intro-page">
      <div className="stage1-intro-scene">
        <div className="stage1-intro-character-wrap">
          <img
            src={character.portrait}
            alt={characterName ?? character.name}
            className="stage1-intro-character"
          />
        </div>

        <div className="stage1-intro-bubble">
          <p className="stage1-intro-bubble-text">{dialogue}</p>
        </div>

        <button
          type="button"
          className="stage1-intro-start-btn"
          onClick={handleStart}
        >
          <img src={startBtnImg} alt="Start game" />
        </button>
      </div>
    </div>
  );
}

export default Stage1Intro;
